import { textFormatter } from "components/Common/formatter";
import NGIDropdownButton from "components/Common/buttons/NGIDropdownButton";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import arrow from "assets/images/svg/arrow-white.svg";
import removeCustomers from "assets/images/svg/remove-customers.svg";
import React from "react";
import CustomLink from "components/Common/buttons/CustomLink";

export const customerBlacklistListColumns = (removeCustomer, classes) => [
  {
    title: "Customer ID",
    dataIndex: "customerId",
    render: id => (
      <CustomLink underlined target="_blank" to={`/customers/customer/${id}`}>
        {id}
      </CustomLink>
    ),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    render: textFormatter,
  },
  {
    title: "Customer Depot",
    dataIndex: "customerDepot",
    render: textFormatter,
  },
  {
    title: "Reason for Adding",
    dataIndex: "addReason",
    render: textFormatter,
  },
  {
    title: "Blacklisted By",
    dataIndex: "blacklistedBy",
    render: textFormatter,
  },
  {
    title: "Comments",
    dataIndex: "comments",
    render: cellData => (
      <div className={classes.overflowText} title={cellData}>
        {textFormatter(cellData)}
      </div>
    ),
  },
  {
    title: "",
    width: "4%",
    key: "action",
    render: (_, row) => (
      <NGIDropdownButton
        position="left"
        toggleEl={<ButtonGroup icon={arrow} />}
        menuItems={[
          {
            label: "Remove from Blacklist",
            icon: removeCustomers,
            callback: () => removeCustomer(row),
          },
        ]}
      />
    ),
  },
];
